// extracted by mini-css-extract-plugin
module.exports = {"h1":"Login_h1__1-T9m"};